import { render, staticRenderFns } from "./ImagesAlignment.vue?vue&type=template&id=93dffb20"
import script from "./ImagesAlignment.vue?vue&type=script&lang=js"
export * from "./ImagesAlignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports